import AuthManager from 'Common/AuthManager';
import { useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import ServiceWrapper from 'Services/ServiceWrapper';

const API_BASE_URL = process.env.REACT_APP_GMS_BACKEND_API_URL || '';

export const useProductModelDownload = () => {
    const [isDownloading, setIsDownloading] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState<string | null>(null);

    const checkDownloadStatus = useCallback(async (jobId: string) => {
        if (!jobId) return
        try {
            const statusResponse = await ServiceWrapper.doGet(
                `${API_BASE_URL}job/status/${jobId}`,
                null,
                null,
                AuthManager.getGmsToken()
            );

            if (!statusResponse.errorfound) {
                const { data } = statusResponse;

                if (data?.error) {
                    setIsDownloading(false);
                    toast.error('Download failed');
                    return;
                }

                if (data?.processing) {
                    setTimeout(() => {
                        checkDownloadStatus(jobId);
                    }, 2000);
                    return;
                }

                // Download completed
                setDownloadUrl(data?.data?.download_url);
                toast.success(data?.status || 'Completed');
                setIsDownloading(false);

                setTimeout(() => {
                    setDownloadUrl(null);
                }, 4000);
            } else {
                setIsDownloading(false);
                toast.error('Error checking download status');
            }
        } catch (error) {
            console.error('Error occurred while checking download status:', error);
            setIsDownloading(false);
            toast.error('Error during download');
        }
    }, []);

    const handleDownload = useCallback(async (
        channelKey: string
    ) => {
        setIsDownloading(true);
        setDownloadUrl(null);

        try {
            const response = await ServiceWrapper.doGet(
                `${API_BASE_URL}override-mappings/download/${channelKey}`,
                null,
                null,
                AuthManager.getGmsToken()
            );

            if (response.errorfound || !response.data?.job_id) {
                toast.error(response.data?.message || 'Failed to initiate download');
                setIsDownloading(false);
                return;
            }

            setTimeout(() => {
                checkDownloadStatus(response.data.job_id);
            }, 1000);
        } catch (error) {
            toast.error('Download failed');
            setIsDownloading(false);
        }
    }, [checkDownloadStatus]);

    return {
        handleDownload,
        isDownloading,
        downloadUrl
    };
};